import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Polyline,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M20 10V7.5L14.5 2H6a2 2 0 0 0-2 2v16c0 1.1.9 2 2 2h4.5",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Polyline, { points: "14 2 14 8 20 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 22a2 2 0 0 1-2-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 22a2 2 0 0 0 2-2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M20 14a2 2 0 0 1 2 2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M16 14a2 2 0 0 0-2 2", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FileScan";
const FileScan = memo(themed(Icon));
export {
  FileScan
};
//# sourceMappingURL=file-scan.js.map
